export const defaultJSON = "";

export function formatRelativeLabel(input?: string | number | Date): string {
  try {
    if (!input) return "";
    const date = new Date(input);
    if (isNaN(date.getTime())) return "";
    
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const minutes = Math.max(0, Math.floor(diffMs / 60000));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(diffMs / 86400000);
    
    // Check if it's today
    const isToday = date.toDateString() === now.toDateString();
    
    // Check if it's yesterday
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    
    if (isToday) {
      // For today, show time in hours and minutes
      if (hours > 0) {
        return `${hours}h ${minutes % 60}m ago`;
      } else {
        return `${minutes}m ago`;
      }
    } else if (isYesterday) {
      // For yesterday, show "Yesterday"
      return "Yesterday";
    } else if (days > 1) {
      // For older dates, show the date
      return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric',
        year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
      });
    } else {
      // Fallback for edge cases
      return `${days} day${days > 1 ? "s" : ""} ago`;
    }
  } catch {
    return "";
  }
}

export function extractPlainTextFromLexical(content: string): string {
  try {
    if (!content) return "";
    const parsed = JSON.parse(content);
    const walk = (node: any): string => {
      if (!node) return "";
      let acc = "";
      if (typeof node.text === "string") acc += node.text;
      if (Array.isArray(node.children)) {
        for (const c of node.children) acc += walk(c);
      }
      return acc;
    };
    return walk(parsed.root) || "";
  } catch {
    return "";
  }
}
